import { render, staticRenderFns } from "./BehaviourTable.vue?vue&type=template&id=d21b4804"
import script from "./BehaviourTable.vue?vue&type=script&lang=js"
export * from "./BehaviourTable.vue?vue&type=script&lang=js"
import style0 from "./BehaviourTable.vue?vue&type=style&index=0&id=d21b4804&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports